<ng-container *ngIf="this.order.orderType == 5">
  <div class="order-history" class="order-history" *ngIf="this.order.orderStatus != 0 && this.order.orderStatus != 9 && this.order.orderStatus != 10">
    <div class="box-time">
      <div class="timer">
        <span class="order-history__box__time">{{ order.createdAt | date:'HH:mm' }}</span>
      </div>
      <ng-container *ngIf="this.order.events" >
        <ng-container *ngFor="let event of this.order.events">

          <ng-container *ngIf="event.orderStatus == 2">
            <div class="timer">
              <span class="order-history__box__time">{{ event.createdAt | date: 'HH:mm' }}</span>
            </div>
          </ng-container>
          <ng-container *ngIf="event.orderStatus == 4">
            <div class="timer">
              <span class="order-history__box__time" >{{ event.createdAt | date: 'HH:mm' }}</span>
            </div>
          </ng-container>
          <ng-container  *ngIf="event.orderStatus == 5">
            <div class="timer">
              <span class="order-history__box__time">{{ event.createdAt | date: 'HH:mm' }}</span>
            </div>
          </ng-container>
          
        </ng-container>
      </ng-container>
    </div>
    <div class="div-order-history">
      <div class="order-history__box" [ngClass]="{'active': order.orderStatus >= 1 }">
        <div class="order-history__box__content">
          <div class="order-history__line">
          </div>
          <div class="order-history__circle">
            <div class="circle-animation" [ngClass]="{'active': order.orderStatus == 1}"></div>
          </div>
          <div class="order-history__line">
            <div class="line-animation"></div>
          </div>
        </div>
      </div>
      <div class="order-history__box " [ngClass]="{'active': order.orderStatus >= 2 && order.production}">
        <div class="order-history__box__content">
          <div class="order-history__line">
          </div>
          <div class="order-history__circle">
            <div class="circle-animation" [ngClass]="{'active': order.orderStatus == 2 && order.production}"></div>
          </div>
          <div class="order-history__line">
            <div class="line-animation"></div>
          </div>
        </div>

      </div>
      <div class="order-history__box" [ngClass]="{'active': order.orderStatus >= 4 }">
        <div class="order-history__box__content">
          <div class="order-history__line">
          </div>
          <div class="order-history__circle">
            <div class="circle-animation" [ngClass]="{'active': order.orderStatus == 4}"></div>
          </div>
          <div class="order-history__line">
            <div class="line-animation"></div>
          </div>
        </div>

      </div>
      <div class="order-history__box" [ngClass]="{'active': order.orderStatus == 5 }">
        <div class="order-history__box__content">
          <div class="order-history__line">
          </div>
          <div class="order-history__circle">
            <div class="circle-animation" [ngClass]="{'active-static': order.orderStatus == 5}"></div>
          </div>
          <div class="order-history__line">
            <div class="line-animation"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="status-name">
      <div class="status">
        <span class="order-history__box__status" [ngClass]="{'active': order.orderStatus >= 1}" *ngIf="!this.order.scheduled">Enviado</span>
        <span class="order-history__box__status" [ngClass]="{'active': order.orderStatus >= 1}" *ngIf="this.order.scheduled">Agendado</span>
      </div>
      <div class="status">
        <span class="order-history__box__status" [ngClass]="{'active': order.orderStatus >= 2 && order.production}">Em preparo</span>
      </div>
      <div class="status">
        <span class="order-history__box__status" [ngClass]="{'active': order.orderStatus >= 4}">A caminho</span>
      </div>
      <div class="status">
        <span class="order-history__box__status" [ngClass]="{'active': order.orderStatus == 5}">Finalizado</span>
      </div>
    </div>

    <!--A caminho do seu endereço-->
    <div class="massage-warning" *ngIf="this.order.orderStatus == 4">
      <div class="warning-icon">
        <i class="fa-regular fa-bell bell-animation"></i>
      </div>
      <span class="text-warningg">Seu pedido está a caminho do seu endereço!</span>
    </div>

    <!--Aguardando a loja aceitar o pedido-->
    <div class="massage-warning" *ngIf="this.order.orderStatus == 1 && !this.order.scheduled && this.company.configs.autoCancel == 0">
      <div class="warning-icon">
        <i class="fa-regular fa-bell bell-animation"></i>
      </div>
      <span class="text-warningg">Aguardando a loja aceitar seu pedido...</span>
    </div>

    <!--Auto cancelamento-->
    <div class="massage-warning-new" *ngIf="this.order.orderStatus == 1 && this.order.onlinePay == 0 && this.company.configs.autoCancel == 1 && (this.order.scheduled && this.order.production || !this.order.scheduled)">
      <div class="warning-icon">
        <i class="fa-regular fa-bell bell-animation"></i>
      </div>
      <div class="box-text">
        <span class="text-warningg">Se a loja não aceitar o pedido dentro do prazo, ele será automaticamente cancelado.</span>
      </div>
    </div>

    <!--Pedido agendando-->
    <div class="massage-warning-new" *ngIf="this.order.orderStatus == 1 && this.order.scheduled && !this.order.production">
      <div class="warning-icon">
        <i class="fa-regular fa-bell bell-animation"></i>
      </div>
      <div class="box-text">
        <span class="text-warningg">Pedido agendado.<br> Notificaremos sobre qualquer atualização.</span>
      </div>
    </div>

    <div class="massage-warning-new" *ngIf="this.order.orderStatus == 2 && this.order.scheduled && !this.order.production">
      <div class="warning-icon">
        <i class="fa-regular fa-bell bell-animation"></i>
      </div>
      <div class="box-text">
        <span class="text-warningg">Pedido aceito.<br> Notificaremos sobre qualquer atualização.</span>
      </div>
    </div>



  </div>
</ng-container>


<ng-container *ngIf="this.order.orderType == 2 || this.order.orderType == 3">
  <div class="order-history" *ngIf="this.order.orderStatus != 0 && this.order.orderStatus != 9 && this.order.orderStatus != 10">
    <div class="box-time">
      <div class="timer">
        <span class="order-history__box__time">{{ order.createdAt | date:'HH:mm' }}</span>
      </div>
      <ng-container *ngIf="this.order.events" >
        <ng-container *ngFor="let event of this.order.events">
          <ng-container *ngIf="event.orderStatus == 2 && order.production">
            <div class="timer">
              <span class="order-history__box__time">{{ event.createdAt | date: 'HH:mm' }}</span>
            </div>
          </ng-container>
          <ng-container *ngIf="event.orderStatus == 3">
            <div class="timer">
              <span class="order-history__box__time" >{{ event.createdAt | date: 'HH:mm' }}</span>
            </div>
          </ng-container>
          <ng-container  *ngIf="event.orderStatus == 5">
            <div class="timer">
              <span class="order-history__box__time">{{ event.createdAt | date: 'HH:mm' }}</span>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>

    <div class="div-order-history">
      <div class="order-history__box" [ngClass]="{'active': order.orderStatus >= 1 }">
        <div class="order-history__box__content">
          <div class="order-history__line">
          </div>
          <div class="order-history__circle">
            <div class="circle-animation" [ngClass]="{'active': order.orderStatus == 1}"></div>
          </div>
          <div class="order-history__line">
            <div class="line-animation"></div>
          </div>
        </div>
      </div>
      <div class="order-history__box" [ngClass]="{'active': order.orderStatus >= 2 && order.production}">
        <div class="order-history__box__content">
          <div class="order-history__line">
          </div>
          <div class="order-history__circle">
            <div class="circle-animation" [ngClass]="{'active': order.orderStatus == 2 && order.production}"></div>
          </div>
          <div class="order-history__line">
            <div class="line-animation"></div>
          </div>
        </div>

      </div>
      <div class="order-history__box" [ngClass]="{'active': order.orderStatus >= 3 }">
        <div class="order-history__box__content">
          <div class="order-history__line">
          </div>
          <div class="order-history__circle">
            <div class="circle-animation" [ngClass]="{'active': order.orderStatus == 3}"></div>
          </div>
          <div class="order-history__line">
            <div class="line-animation"></div>
          </div>
        </div>
      </div>
      <div class="order-history__box" [ngClass]="{'active': order.orderStatus >= 5 }">
        <div class="order-history__box__content">
          <div class="order-history__line">
          </div>
          <div class="order-history__circle">
            <div class="circle-animation" [ngClass]="{'active-static': order.orderStatus == 5}"></div>
          </div>
          <div class="order-history__line">
            <div class="line-animation"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="status-name">
      <div class="status">
        <span class="order-history__box__status" [ngClass]="{'active': order.orderStatus >= 1}" *ngIf="!this.order.scheduled">Enviado</span>
        <span class="order-history__box__status" [ngClass]="{'active': order.orderStatus >= 1}" *ngIf="this.order.scheduled">Agendado</span>
      </div>
      <div class="status">
        <span class="order-history__box__status" [ngClass]="{'active': order.orderStatus >= 2 && order.production}">Em preparo</span>
      </div>
      <div class="status">
        <span class="order-history__box__status" [ngClass]="{'active': order.orderStatus >= 3}">Pronto</span>
      </div>
      <div class="status">
        <span class="order-history__box__status" [ngClass]="{'active': order.orderStatus >= 5}">Finalizado</span>
      </div>
    </div>

    <!--Pronto para retirada no balcão-->
    <div class="massage-warning" *ngIf="this.order.orderStatus == 3">
      <div class="warning-icon">
        <i class="fa-regular fa-bell bell-animation"></i>
      </div>
      <span class="text-warningg">Seu pedido está pronto para retirada no balcão!</span>
    </div>

    <!--Aguardando a loja aceitar o pedido-->
    <div class="massage-warning" *ngIf="this.order.orderStatus == 1 && !this.order.scheduled && this.company.configs.autoCancel == 0">
      <div class="warning-icon">
        <i class="fa-regular fa-bell bell-animation"></i>
      </div>
      <span class="text-warningg">Aguardando a loja aceitar seu pedido...</span>
    </div>

    <!--Auto cancelamento-->
    <div class="massage-warning-new" *ngIf="this.order.orderStatus == 1 && this.order.onlinePay == 0 && this.company.configs.autoCancel == 1 && (this.order.scheduled && this.order.production || !this.order.scheduled)">
      <div class="warning-icon">
        <i class="fa-regular fa-bell bell-animation"></i>
      </div>
      <div class="box-text">
        <span class="text-warningg">Se a loja não aceitar o pedido dentro do prazo, ele será automaticamente cancelado.</span>
      </div>
    </div>

    <!--Pedido agendando-->
    <div class="massage-warning-new" *ngIf="this.order.orderStatus == 1 && this.order.scheduled && !this.order.production">
      <div class="warning-icon">
        <i class="fa-regular fa-bell bell-animation"></i>
      </div>
      <div class="box-text">
        <span class="text-warningg">Pedido agendado.<br> Notificaremos sobre qualquer atualização.</span>
      </div>
    </div>

    <div class="massage-warning-new" *ngIf="this.order.orderStatus == 2 && this.order.scheduled && !this.order.production">
      <div class="warning-icon">
        <i class="fa-regular fa-bell bell-animation"></i>
      </div>
      <div class="box-text">
        <span class="text-warningg">Pedido aceito.<br> Notificaremos sobre qualquer atualização.</span>
      </div>
    </div>
  </div>
</ng-container>
